import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useFetchEligibilityQuery } from './api';
import { openSeatRequestModal } from './slice';
import { TRACKING_EVENT_NAMES, useTrack, useTrackOnce } from '../../hooks/analytics_events';
import { useSeatRequestExperimentEnabled } from '../../hooks/growth_experiments/use-seat-request-experiment';
const mainWrapperCss = "mh0dwul";
const MainWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mainWrapperCss, props.className)} />;
});
const contentWrapperCss = "c12co4cn";
const ContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentWrapperCss, props.className)} />;
});
const joinButtonCss = "j1ca0n1l";
const JoinButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(joinButtonCss, props.className)} />);
const textWrapperCss = "t1gmnnr2";
const TextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textWrapperCss, props.className)} />;
});
const BannerContent = ({
  setDismissed
}) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    setDismissed(true);
    window.localStorage.setItem('seat_requests_experiment_banner_dismissed', true);
  };
  const track = useTrack();
  useTrackOnce(true, {
    name: TRACKING_EVENT_NAMES.CTA_SHOWN,
    properties: {
      cta_destination: 'join_existing_org_modal',
      cta_key: 'scheduling_page',
      cta_text: 'join_an_existing_organization',
      cta_details: 'we_found_your_organization_request_to_join_so_you_can_collaborate_with_your_teammates'
    }
  });
  return <MainWrapper>
      <ContentWrapper>
        <TextWrapper>
          {I18n.t('publisher.growth_experiments.seat_requests.homepage_banner.text')}
          &ensp;
          <JoinButton onClick={() => {
          track({
            name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
            properties: {
              action: 'opening',
              modal_name: 'join_existing_org',
              modal_details: 'join_with_your_organization',
              location: 'scheduling_page',
              path: window.location.pathname
            }
          });
          dispatch(openSeatRequestModal({
            openedFrom: 'scheduling_page'
          }));
        }}>
            {I18n.t('publisher.growth_experiments.seat_requests.homepage_banner.cta')}
          </JoinButton>
        </TextWrapper>

        <div>
          <IconButton title="Close" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </ContentWrapper>
    </MainWrapper>;
};
const SelectiveRenderer = ({
  setDismissed
}) => {
  // One more parent modal so we don't make an API call for people who have dismissed/don't have the experiment enabled
  const {
    isLoading,
    data,
    isError
  } = useFetchEligibilityQuery();
  if (isLoading || isError) return null;
  if (data?.existingRequest || !data?.eligible) return null;
  return <BannerContent setDismissed={setDismissed} />;
};
export const SeatRequestsBanner = () => {
  const isSeatRequestsExperimentEnabled = useSeatRequestExperimentEnabled();
  const [dismissed, setDismissed] = useState(window.localStorage.getItem('seat_requests_experiment_banner_dismissed'));
  if (dismissed) return null;
  if (!isSeatRequestsExperimentEnabled) return null;
  return <SelectiveRenderer setDismissed={setDismissed} />;
};

require("./seat_requests_banner.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./seat_requests_banner.js");